import React, { Component } from 'react';
import CategoriesMain from '../../components/Categories/';
import LayoutPreload from '../../components/Preload/layout.preload';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions';
import NotFound from '../notfound/'
import _ from 'lodash';

class CategoriesPage extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
            category: {},
            notFound: false
        }
    }

    async componentWillMount() {
        const { getNavbarCategory, match, categories } = this.props;
        if (categories.length === 0) await getNavbarCategory();
        
        this.getDataCategory(`/${match.params.categoryName}`);
    }

    componentDidUpdate(prevProps) {
        if (
            !_.isEqual(prevProps.match.params.categoryName, this.props.match.params.categoryName) || 
            !_.isEqual(prevProps.currentLanguage, this.props.currentLanguage)
        ) {
            this.getDataCategory(`/${this.props.match.params.categoryName}`);
        }
    }

    getDataCategory = async (pathname) => {
        const {
            updateWording,
            CategoryNameChange,
            ItemByCategoryName,
            categories
        } = this.props;
        let category = categories.find(category => category.url == pathname);
        if (category == undefined) {
            await this.setState({ notFound: true });
            return;
        } else {
            await this.setState({ notFound: false });
        }
        updateWording();
        await CategoryNameChange(category.categoryNameTh);
        await ItemByCategoryName();
        await this.setState({ category: category });
    }

    render() {
        const { categoryFetching } = this.props;
        const { category, notFound } = this.state;

        if (categoryFetching) {
            return <LayoutPreload />;
        } else if (notFound) {
            return <NotFound />;
        }
        return <CategoriesMain category={category} />;
    }
}

const mapStateToProps = ({ categories, navigation, language }) => ({
    categoryFetching: categories.categoryFetching,
    categories: navigation.navbarCategory,
    currentLanguage: language.currentLanguage
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            updateWording: Actions.updateWording,
            CategoryNameChange: Actions.CategoryNameChange,
            ItemByCategoryName: Actions.ItemByCategoryName,
            getNavbarCategory: Actions.getNavbarCategory
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesPage);